import { Box, Button, Card, CircularProgress, Typography } from "@mui/material";
import { useCustomMutation } from "@refinedev/core";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import { useQueryClient } from "@tanstack/react-query";

export const ReAuthenticationCallback = () => {
  const { translate } = useTranslation("pages.stores.reAuthentication");
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const { mutate } = useCustomMutation();
  const queryClient = useQueryClient();
  const [authorizationState, setAuthorizationState] = useState<
    "initial" | "loading" | "error"
  >("initial");

  useEffect(() => {
    tryReAuthorize();
  }, []);

  const handleReAuthorization = (
    authCode: string,
    state: string,
    amazonSellerId: string,
    marketplaceId: string,
  ) => {
    if (authorizationState === "loading") return;
    setAuthorizationState("loading");

    mutate(
      {
        url: "authorization/complete",
        method: "post",
        values: {
          authCode,
          state,
          amazonSellerId,
          marketplaceId: parseInt(marketplaceId),
        },
      },
      {
        onError: () => {
          setAuthorizationState("error");
        },
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ["initialMarketplace"],
          });

          // Clear re-authentication flags
          localStorage.removeItem("reAuthenticating");
          localStorage.removeItem("marketplaceId");

          setTimeout(() => {
            navigate("/");
            navigate(0); // Force refresh
          }, 1000);
        },
      },
    );
  };

  const tryReAuthorize = () => {
    const authCode = searchParams.get("spapi_oauth_code");
    const amazonSellerId = searchParams.get("selling_partner_id");
    const state = searchParams.get("state");
    const isReAuthenticating = localStorage.getItem("reAuthenticating");
    const marketplaceId = localStorage.getItem("marketplaceId");

    if (
      authCode &&
      state &&
      isReAuthenticating &&
      marketplaceId &&
      amazonSellerId
    ) {
      handleReAuthorization(authCode, state, amazonSellerId, marketplaceId);
    } else {
      // If not in re-authentication flow, redirect to home
      navigate("/");
    }
  };

  return (
    <Box width="100%" display="flex" justifyContent="center">
      <Card
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "24px",
          width: "fit-content",
          height: "200px",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6">
          {authorizationState === "error"
            ? translate("error")
            : translate("reAuthorizing")}
        </Typography>
        {authorizationState === "error" ? (
          <Button variant="contained" onClick={tryReAuthorize}>
            {translate("tryAgain")}
          </Button>
        ) : (
          <CircularProgress />
        )}
      </Card>
    </Box>
  );
};
